// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetReviewsResponseV2 } from '../../entities/web_entities/GetReviewsResponseV2';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetReviewsRequest {
  canViewTest?: boolean;
  fromLastReviewId?: string;
  offset?: number;
  realtyUserId: number;
  sortType?: EQueryParameters;
}

export enum EQueryParameters {
  /** Сортировка по полезности отзыва **/
  'Useful' = 'useful',
  /** Сначала новые отзывы **/
  'New' = 'new',
  /** Сначала старые отзывы **/
  'Old' = 'old',
  /** Сначала с наибольшей оценкой **/
  'MaxRate' = 'maxRate',
  /** Сначала с наименьшей оценкой **/
  'MinRate' = 'minRate',
}
export type TGetReviewsResponse =
  | FetchModelResponse<200, 'json', IGetReviewsResponseV2>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetReviewsModel = IFetchModel<IGetReviewsRequest, undefined, TGetReviewsResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetReviewsResponseV2, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
